import React from 'react'
import type { CompanyNode } from '@/modules/companies'
import { UserNameFormat } from '@/modules/companies'

export const CompanyContext = React.createContext<CompanyNode>({
  id: '',
  shortName: '',
  fullName: '',
  language: '',
  country: '',
  logo: '',
  useCompanyLogo: false,
  numberOfUsers: 0,
  userTypes: [],
  leaderGroups: [],
  salaryGroups: [],
  moduleConfigs: [],

  notificationSettings: [],
  useOrdinaryHourCalculation: false,
  infringementAdminSeverityNotificationThreshold: null,
  userNameFormat: UserNameFormat.FirstLast,
  userHasAccess: false,
})
